import { Box } from '@factorialco/deprecated-design-system'

import { ActivationCenter } from './ActivationCenter'

export const Header = () => {
  return (
    <Box width="full" flexDirection="column" gap="s12" alignItems="flexEnd">
      <ActivationCenter />
    </Box>
  )
}
